import type { ProductConfigDefinition } from 'Models/uiConfig/productConfig.types';

import { getCurrency, getFitmentUpdatedAt, getLocale, getProductId, getVariantId } from './helpers';

const locale = getLocale();
const activeCurrency = getCurrency();

export default {
  fields: {
    id: 'id',
    image: 'image',
    title: 'title',
    url: 'url',
    price: 'price',
    /* eslint-disable camelcase */
    variant_ids: 'variant_ids',
    compare_at_price: 'compare_at_price',
    /* eslint-enable camelcase */
  },
  entityIdField: 'variant_ids',
  getItemId(): string {
    const productId = getProductId();
    if (productId) {
      return `${productId}`;
    }

    console.warn('Product id not found');
    return '';
  },
  getVariantId(): string {
    const variantId = getVariantId();
    if (variantId) {
      return `${variantId}`;
    }

    console.warn('Variant id not found');
    return '';
  },
  getFitmentUpdatedAt,
  dropdownImageWidth: 100,
  dropdownImageHeight: 100,
  searchResultsImageWidth: 300,
  searchResultsImageHeight: 300,
  priceFormatter: activeCurrency
    ? new Intl.NumberFormat(locale, { style: 'currency', currency: activeCurrency })
    : null,
} satisfies ProductConfigDefinition;
